import { Heading } from '@lmig/lmds-react-typography';
import { FavoritesPanelType, ISliderContext, SLIDERPANELTYPES } from '../Models/Panels';
import { AccordionLinks } from './AccordionLinks';
import './FavoritesPanel.scss';
import { SliderContext } from '../SliderContext';
import { useEffect, useContext, useState } from 'react';
import { SearchInput } from '@lmig/lmds-react-alphanumeric-input';
import SitecoreLink from 'Foundation/GlassMapper/SitecoreLink';
import { Link } from '@lmig/lmds-react-link';

interface IFavoritesPanel {
  panel: FavoritesPanelType;
}
export function FavoritesPanel({ panel }: IFavoritesPanel) {
  const sliderContext = useContext<ISliderContext>(SliderContext);
  const [localPanel, setLocalPanel] = useState<FavoritesPanelType>(panel);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (localPanel && !sliderContext.panels) sliderContext.addPanel(localPanel);
    else if (!localPanel && sliderContext.panels && sliderContext.panels.length) {
      let _panel = sliderContext.panels.find((x) => {
        if (x.type != SLIDERPANELTYPES.LINKSPANEL && x.link && x.link.includes('https'))
          return new URL(x.link).pathname === window.location.pathname;
        else return x.type != SLIDERPANELTYPES.LINKSPANEL && x.link === window.location.pathname;
      });
      if (_panel && _panel.type === SLIDERPANELTYPES.FAVORITESPANEL) setLocalPanel(_panel);
    }
  }, [sliderContext, sliderContext.panels, localPanel]);

  if (localPanel)
    return (
      <>
        <Heading type="h4">{localPanel.title}</Heading>
        <div data-theme="evolved">
          <SearchInput
            id={`${localPanel.title?.toLowerCase().replaceAll(' ', '-')}-search`}
            labelVisual={`Search ${localPanel.title?.toLowerCase()}`}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            aria-live="polite"
            onClearClicked={() => setSearchValue('')}
          />
        </div>
        {localPanel.link && (
          <SitecoreLink
            Class="full-page-view-link"
            Target="_self"
            Text={'Full page view'}
            Url={localPanel.link}
            CaretPosition="right"
          />
        )}
        {searchValue.length == 0 && (
          <div className="favorites-section">
            <Heading type="h5">Favorites</Heading>
            <div className="menu-section-links">
              <Link variant="standalone" href="/manage-my-favorites">
                Manage all favorites
              </Link>
            </div>
          </div>
        )}
        <AccordionLinks
          sections={localPanel.sections}
          filterTerm={searchValue}
          usesFavorites={true}
          id={localPanel.title}
        />
      </>
    );
  else return <></>;
}

export default FavoritesPanel;
